// This file is generated by a script and should not be modified directly.
const markdown: string = "Filtrer les offres d’emploi par département. Ce paramètre accepte un tableau de numéros de départements\n"
export default markdown
